const uiSchema = {
  "ui:order": [
    "region",
    "insuredPerilCode",
    "insuredPolicyNumber",
    "insuredName",
    "insuredtel",
    "clientEmail",
    "brokerage",
    "brokerName",
    "brokeremail",
    "claimtypeCat",
    "claimMotor",
    "claimNonMotor",
    "subCoi",
    "claimMotorCauseOfLoss",
    "claimNonMotorCauseOfLoss",
    "CausedBy",
    "NonMotorCausedBy",
    "*"
  ],
  claimtype: {
    classNames: "hidden"
  },
  subCoi: {
    classNames: "hidden"
  },
  claimMotorCauseOfLoss: {
    classNames: "hidden"
  },
  claimNonMotorCauseOfLoss: {
    classNames: "hidden"
  },
  CausedBy: {
    classNames: "hidden"
  },
  NonMotorCausedBy: {
    classNames: "hidden"
  },
  claimNonMotorCausedBy: {
    classNames: "hidden"
  },
  thirdparty: {
    classNames: "hidden"
  }
};

export default uiSchema;
